/* eslint-disable react/require-default-props */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import classnames from 'classnames';
import { CirclePicker } from 'react-color';
import { ActionButton } from '../../../../components/Buttons/ActionButton/ActionButton';
import { Button } from '../../../../components/Buttons/Button/Button';
import { PROFILE_HEADER_BACKGROUND_COLORS } from '../../consts';

export class ProfileHeaderBackground extends PureComponent {
  static propTypes = {
    user: ImmutablePropTypes.map,
    profilePage: ImmutablePropTypes.map,
    hasEditAccess: PropTypes.bool,
    updateProfilePageHeaderColorPreview: PropTypes.func,
    updateProfileColor: PropTypes.func,
    updateProfilePageHeaderColorSaving: PropTypes.func,
    updateProfilePageHeaderColorPicker: PropTypes.func,
  };

  onColorButtonClick = () => {
    const {
      user,
      updateProfilePageHeaderColorPicker,
      profilePage,
    } = this.props;

    updateProfilePageHeaderColorPicker(
      user.get('profileName'),
      !profilePage.get('headerColorPicker', false)
    );
  };

  onColorChanged = (color) => {
    const { updateProfilePageHeaderColorPreview, user } = this.props;

    updateProfilePageHeaderColorPreview(user.get('profileName'), color.hex);
  };

  onColorSaveClick = () => {
    const {
      user,
      profilePage,
      updateProfileColor,
      updateProfilePageHeaderColorPicker,
      updateProfilePageHeaderColorSaving,
    } = this.props;

    updateProfilePageHeaderColorSaving(user.get('profileName'), false);
    updateProfileColor(
      user.get('profileName'),
      profilePage.get('headerColor')
    ).then(() => {
      updateProfilePageHeaderColorPicker(user.get('profileName'), false);
      updateProfilePageHeaderColorSaving(user.get('profileName'), false);
    });
  };

  onColorCancelClick = () => {
    const {
      user,
      updateProfilePageHeaderColorPreview,
      updateProfilePageHeaderColorPicker,
    } = this.props;

    updateProfilePageHeaderColorPreview(
      user.get('profileName'),
      user.get('profileHeaderColor')
    );
    updateProfilePageHeaderColorPicker(user.get('profileName'), false);
  };

  render() {
    const {
      user,
      hasEditAccess,
      profilePage,
      updateProfilePageHeaderColorPicker,
    } = this.props;

    const headerColorStyle = {
      backgroundColor: profilePage.get('headerColor'),
    };
    const headerColorPicker = profilePage.get('headerColorPicker', false);
    const headerColorSaving = profilePage.get('headerColorSaving', false);

    if (hasEditAccess) {
      return (
        <header
          role="banner"
          className="header-background"
          style={headerColorStyle}
        >
          <div className="header-background-color">
            <Button
              label="Change theme color"
              icon="edit"
              onClick={this.onColorButtonClick}
              className={classnames('header-background-color-button', {
                'header-background-color-button-pressed': headerColorPicker,
              })}
            />
            {headerColorPicker && (
              <div className="header-background-color-config">
                <div className="header-background-color-picker">
                  <CirclePicker
                    circleSpacing={10}
                    color={profilePage.get('headerColor')}
                    colors={PROFILE_HEADER_BACKGROUND_COLORS}
                    onChangeComplete={(newColor) => {
                      this.onColorChanged(newColor);
                    }}
                  />
                </div>
                <div className="header-background-color-config-buttons">
                  <ActionButton
                    className="header-background-color-config-button"
                    label="Save"
                    onClick={this.onColorSaveClick}
                    onSuccess={() => {
                      updateProfilePageHeaderColorPicker(
                        user.get('profileName'),
                        false
                      );
                    }}
                    onError={() => {
                      updateProfilePageHeaderColorPicker(
                        user.get('profileName'),
                        false
                      );
                    }}
                  />
                  <Button
                    className="header-background-color-config-button"
                    label="Cancel"
                    onClick={this.onColorCancelClick}
                    disabled={headerColorSaving}
                  />
                </div>
              </div>
            )}
          </div>
        </header>
      );
    } else {
      return (
        <header
          role="banner"
          className="header-background"
          style={headerColorStyle}
        />
      );
    }
  }
}
